import {
  Component,
  Input,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  OnInit,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core'
import { AbstractControl, FormGroup } from '@angular/forms'

import { isInApp } from 'libs/shared/utils/helpers/src/'
import { Subscription } from 'rxjs'
import { FieldTypeEnum } from 'libs/shared/models/shared.models'
import { GbBaseQuestion } from '../gb-base-question'

@Component({
  selector: 'gb-dynamic-form-question',
  templateUrl: './gb-dynamic-form-question.component.html',
  styleUrls: ['./gb-dynamic-form-question.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbDynamicFormQuestionComponent implements OnInit, OnDestroy {
  @Input() question!: GbBaseQuestion<string | boolean>
  @Input() form!: FormGroup
  googlePlacesValidAddress: boolean | undefined = undefined
  controlType = FieldTypeEnum

  get isValid() {
    return this.formControl.valid
  }

  get formControl(): AbstractControl {
    return this.form.controls[this.question.key]
  }

  showRequiredMessage = false
  statusChangesSub?: Subscription

  constructor(private _changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.watchStatusChanges()
  }

  ngOnDestroy(): void {
    this.statusChangesSub?.unsubscribe()
  }

  watchStatusChanges(): void {
    this.statusChangesSub = this.formControl.statusChanges.subscribe((data) => {
      this.showRequiredMessage = this.formControl.touched && this.question.required && !this.isValid
      this._changeDetectorRef.detectChanges()
    })
  }

  addressPlaceResultCallback(address: any) {
    this.googlePlacesValidAddress = true
    const addressForm = this.form.get(this.question.key)
    if (addressForm) {
      addressForm.setValue(address.formatted_address)
    }
  }

  /**
   * check if it is an in app browser and do not render the address autocomplete as it will not work
   * */
  shouldUseMapAutocomplete() {
    return !isInApp()
  }
}
